export default function Events() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const events = [
    {
      id: 1,
      type: 'Birthday Parties',
      name: 'Ultimate Ninja Birthday',
      description: 'Make their special day unforgettable with an action-packed ninja warrior party.',
      features: [
        'Private facility access',
        'Dedicated party host',
        'Obstacle course challenges',
        'Party room included'
      ],
      image: 'https://public.readdy.ai/ai/img_res/c6fbc6c48fc15933b6502bfc1bc70fe0.jpg',
      popular: true
    },
    {
      id: 2,
      type: 'Private Events',
      name: 'Group Training Sessions',
      description: 'Book the entire facility for your group, team, or organization.',
      features: [
        'Customized training programs',
        'Professional coaching',
        'Flexible scheduling',
        'All skill levels welcome'
      ],
      image: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/52f1a67c-c37b-49ec-8931-88383aab9c4e_570091244_18292994875286126_3811903537701828920_n.jpg?v=e91162d4fa0b7633f64997efa3fbb3f7',
      popular: false
    },
    {
      id: 3,
      type: 'Team Building',
      name: 'Corporate Challenges',
      description: 'Build stronger teams through collaborative obstacle challenges and competitions.',
      features: [
        'Team-building activities',
        'Leadership development',
        'Communication exercises',
        'Catering options available'
      ],
      image: 'https://readdy.ai/api/search-image?query=professional%20business%20team%20working%20together%20on%20ninja%20warrior%20obstacles%20in%20corporate%20team%20building%20event%2C%20collaborative%20athletic%20environment%20with%20simple%20clean%20background&width=560&height=400&seq=team-building-010&orientation=landscape',
      popular: false
    },
    {
      id: 4,
      type: 'Competitions',
      name: 'Ninja Competitions',
      description: 'Host or participate in exciting ninja warrior competitions and tournaments.',
      features: [
        'Competitive courses',
        'Timing systems',
        'Awards and prizes',
        'Spectator seating'
      ],
      image: 'https://storage.readdy-site.link/project_files/8c606bec-a1c4-4337-82da-c52a0844d7ac/fccd3963-8807-4f6c-86ec-95c8494b9083_586630781_1381066390696384_7403728630202659130_n.jpg?v=d34c5a5f81fbb6c33e8abeb1368b890d',
      popular: false
    }
  ];

  return (
    <section id="events" className="py-24 bg-[#0A1628] relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-20 text-white text-9xl">
          <i className="ri-trophy-line"></i>
        </div>
        <div className="absolute bottom-20 left-20 text-white text-9xl">
          <i className="ri-team-line"></i>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="mb-20">
          <div className="mb-4">
            <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-wider">
              Events &amp; Parties
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-6 max-w-2xl">
            Host Your Next Event
          </h2>
          <p className="text-white/80 text-base sm:text-xl max-w-2xl">
            From birthday parties to corporate team building, create unforgettable experiences at Tri County Ninja.
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {events.map((event) => (
            <div
              key={event.id}
              className={`bg-white rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 ${
                event.popular ? 'ring-4 ring-[#FF6B35]' : ''
              }`}
            >
              <div className="flex flex-col sm:flex-row">
                {/* Image */}
                <div className="sm:w-2/5 h-52 sm:h-auto relative">
                  <img
                    src={event.image}
                    alt={event.name}
                    className="w-full h-full object-cover object-center"
                  />
                  {event.popular && (
                    <div className="absolute top-4 right-4 bg-[#FF6B35] text-white px-4 py-2 rounded-full text-xs font-bold uppercase">
                      Popular
                    </div>
                  )}
                  <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#FF6B35]"></div>
                </div>

                {/* Content */}
                <div className="sm:w-3/5 p-6 sm:p-8">
                  <div className="text-[#FF6B35] text-sm font-bold uppercase tracking-wide mb-2">
                    {event.type}
                  </div>
                  <h3 className="text-2xl font-bold text-[#0A1628] mb-3">
                    {event.name}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {event.description}
                  </p>

                  {/* Features */}
                  <ul className="space-y-2 mb-6">
                    {event.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-sm text-gray-700">
                        <i className="ri-check-line text-[#FF6B35] mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  <button
                    onClick={() => scrollToSection('contact')}
                   className="border-2 border-[#FF6B35] text-[#FF6B35] px-6 py-3 rounded-full font-semibold hover:bg-[#FF6B35] hover:text-white transition-all duration-300 flex items-center whitespace-nowrap cursor-pointer">
                    {event.type === 'Birthday Parties' ? 'Book an Event' : 'Request Info'}
                    <i className="ri-arrow-right-line ml-2"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-white/80 text-lg mb-6">
            Have a unique event idea? We'd love to make it happen!
          </p>
          <button 
          onClick={() => scrollToSection('contact')}
          className="bg-[#FF6B35] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
            Contact Us for Custom Events
          </button>
        </div>
      </div>

      {/* Diagonal Cut */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-white transform origin-top-left skew-y-2"></div>
    </section>
  );
}